// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFooter_root__q7guq","innerWrap":"ModalFooter_innerWrap__fT7nH","submitBtnDisabled":"ModalFooter_submitBtnDisabled__2VTG3"};